export const TEMPLATE_CATEGORIES = [
  { key: 'all', labelKey: 'AUTOMATION.TEMPLATES.CATEGORIES.ALL' },
  { key: 'support', labelKey: 'AUTOMATION.TEMPLATES.CATEGORIES.SUPPORT' },
  { key: 'sales', labelKey: 'AUTOMATION.TEMPLATES.CATEGORIES.SALES' },
  {
    key: 'notifications',
    labelKey: 'AUTOMATION.TEMPLATES.CATEGORIES.NOTIFICATIONS',
  },
];

export const TEMPLATE_EVENTS = [
  { key: 'conversation_created', icon: 'i-lucide-message-square-plus' },
  { key: 'conversation_updated', icon: 'i-lucide-message-square-more' },
  { key: 'conversation_resolved', icon: 'i-lucide-circle-check' },
  { key: 'conversation_opened', icon: 'i-lucide-message-square-text' },
  { key: 'message_created', icon: 'i-lucide-message-circle' },
  { key: 'deal_created', icon: 'i-lucide-handshake' },
  { key: 'deal_moved', icon: 'i-lucide-arrow-right-left' },
  { key: 'deal_created_or_moved', icon: 'i-lucide-git-compare-arrows' },
];

export const AUTOMATION_TEMPLATES = [
  {
    id: 'welcome',
    titleKey: 'AUTOMATION.TEMPLATES.ITEMS.WELCOME',
    category: 'support',
    event: 'conversation_created',
    icon: 'i-lucide-hand',
    color: 'bg-n-teal-3 text-n-teal-11',
  },
  {
    id: 'assign_team',
    titleKey: 'AUTOMATION.TEMPLATES.ITEMS.ASSIGN_TEAM',
    category: 'support',
    event: 'conversation_created',
    icon: 'i-lucide-users',
    color: 'bg-n-blue-3 text-n-blue-11',
  },
  {
    id: 'label_keyword',
    titleKey: 'AUTOMATION.TEMPLATES.ITEMS.LABEL_KEYWORD',
    category: 'support',
    event: 'message_created',
    icon: 'i-lucide-tag',
    color: 'bg-n-amber-3 text-n-amber-11',
  },
  {
    id: 'notify_resolved',
    titleKey: 'AUTOMATION.TEMPLATES.ITEMS.NOTIFY_RESOLVED',
    category: 'notifications',
    event: 'conversation_resolved',
    icon: 'i-lucide-bell-ring',
    color: 'bg-n-ruby-3 text-n-ruby-11',
  },
  {
    id: 'sale_conversion',
    titleKey: 'AUTOMATION.TEMPLATES.ITEMS.SALE_CONVERSION',
    category: 'sales',
    event: 'deal_moved',
    icon: 'i-lucide-badge-dollar-sign',
    color: 'bg-n-teal-3 text-n-teal-11',
  },
  {
    id: 'notify_new_deal',
    titleKey: 'AUTOMATION.TEMPLATES.ITEMS.NOTIFY_NEW_DEAL',
    category: 'sales',
    event: 'deal_created',
    icon: 'i-lucide-handshake',
    color: 'bg-n-violet-3 text-n-violet-11',
  },
];
